/* ab-about.js — 關於我們頁的捲動效果（首屏挖字、數字、時間軸、願景擦拭、影像畫框、輪播）
   每個 section 都會 <script src> 這支；用 window.__abAboutInit 擋住重複執行（skill 坑 #4）。 */
(function () {
  'use strict';
  if (window.__abAboutInit) return;
  window.__abAboutInit = true;
  document.documentElement.classList.add('ab-js');

  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var smooth = function (e0, e1, x) { var t = clamp((x - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  var pageTop = function (el) { return el.getBoundingClientRect().top + window.scrollY; };
  var mqM = window.matchMedia('(max-width: 900px)');
  var isMobile = function () { return mqM.matches; };

  /* ---------- 淡入 ---------- */
  (function () {
    var els = document.querySelectorAll('.ab .ab-fade');
    if (!els.length || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- 首屏 ---------- */
  var hero = (function () {
    var root = document.querySelector('.ab-hero');
    if (!root) return { measure: function () {}, update: function () {} };
    var wrap = root.querySelector('.ab-hero__wrap');
    var mask = root.querySelector('.ab-hero__mask');
    var cut = root.querySelector('.ab-hero__cut');
    var kicker = root.querySelector('.ab-hero__lead');
    var brand = root.querySelector('.ab-hero__brand');
    var ind = root.querySelector('.ab-hero__ind');
    var css = getComputedStyle(root);
    var MAX = parseFloat(css.getPropertyValue('--ab-max-scale')) || 48;
    var SP = parseFloat(css.getPropertyValue('--ab-scale-portion')) || 0.76;
    var dpr = Math.max(1, window.devicePixelRatio || 1);
    var maxK = MAX, start = 0, end = 1, vh = window.innerHeight;

    // 媒體就緒淡入（圖或影片）
    root.querySelectorAll('.ab-hero__media').forEach(function (m) {
      var ready = function () { m.classList.add('is-ready'); };
      if (m.tagName === 'VIDEO') { if (m.readyState >= 3) ready(); m.addEventListener('loadeddata', ready, { once: true }); m.addEventListener('canplay', ready, { once: true }); }
      else { if (m.complete && m.naturalWidth > 0) ready(); m.addEventListener('load', ready, { once: true }); m.addEventListener('error', ready, { once: true }); }
    });

    var leadOff = 0, brandOff = 0;
    function measure() {
      vh = window.innerHeight;
      start = pageTop(wrap);
      end = start + wrap.offsetHeight - vh;
      // 三段（一段話／大字／logo）之間的空隙一律相等：用實際高度算，不用固定百分比
      var gap = parseFloat(getComputedStyle(root).getPropertyValue('--ab-gap')) || 56;
      var cutH = cut ? cut.getBoundingClientRect().height / (parseFloat(cut.dataset.k || '1')) : 0;
      var leadH = kicker ? kicker.getBoundingClientRect().height : 0;
      var brandH = brand ? brand.getBoundingClientRect().height : 0;
      leadOff = -(cutH / 2 + gap + leadH / 2);
      brandOff = cutH / 2 + gap + brandH / 2;
      // 放大倍率被貼圖上限壓住（手機 GPU 貼圖 4096）
      if (cut) {
        var baseW = Math.max(1, cut.getBoundingClientRect().width / (parseFloat(cut.dataset.k || '1')));
        var SAFE = isMobile() ? 4096 : 12288;
        maxK = Math.max(1, Math.min(MAX, (SAFE / dpr) / baseW));
      }
    }
    function update(y) {
      var t = clamp((y - start) / (end - start), 0, 1);
      var p = t < SP ? t / SP : 1;
      var k = 1 + (maxK - 1) * p;
      if (cut) { cut.dataset.k = k; cut.style.transform = 'translateZ(0) scale(' + k + ')'; cut.style.opacity = (1 - smooth(0, 1, p)).toFixed(3); }
      if (mask) { mask.style.opacity = (1 - smooth(SP, 1, t)).toFixed(3); mask.style.mixBlendMode = t > 0.82 ? 'normal' : 'lighten'; }
      var ui = clamp(1 - t * 1.2, 0, 1);
      var drift = 0.2 * vh * t; // 捲動時上下兩段各自往外飄
      if (kicker) { kicker.style.opacity = ui.toFixed(3); kicker.style.transform = 'translate(-50%,-50%) translate3d(0,' + (leadOff - drift).toFixed(1) + 'px,0)'; }
      if (brand) { brand.style.opacity = ui.toFixed(3); brand.style.transform = 'translate(-50%,-50%) translate3d(0,' + (brandOff + drift).toFixed(1) + 'px,0)'; }
      if (ind) { ind.style.opacity = ui.toFixed(3); ind.style.transform = 'translate(-50%,0) translate3d(0,' + (t * 700) + '%,0)'; }
    }
    if (ind) ind.addEventListener('click', function () {
      var next = root.closest('.shopify-section') ? root.closest('.shopify-section').nextElementSibling : root.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return { measure: measure, update: update };
  })();

  /* ---------- 數字跑動 ---------- */
  (function () {
    var sec = document.querySelector('.ab-stats');
    if (!sec) return;
    var counters = sec.querySelectorAll('.ab-stats__num[data-target]');
    var started = false;
    var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
    function run() {
      var t0 = performance.now();
      counters.forEach(function (el) {
        var dur = parseInt(el.dataset.duration || '2400', 10);
        var target = parseFloat(el.dataset.target || '0');
        var prefix = el.dataset.prefix || '', suffix = el.dataset.suffix || '';
        var fmt = function (n) { return target < 10000 ? String(n) : n.toLocaleString(); };
        var step = function (now) {
          var t = Math.min(1, (now - t0) / dur);
          el.textContent = prefix + fmt(Math.floor(ease(t) * target)) + suffix;
          if (t < 1) requestAnimationFrame(step); else el.textContent = prefix + fmt(target) + suffix;
        };
        requestAnimationFrame(step);
      });
    }
    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; }) && !started) { started = true; run(); io.disconnect(); }
    }, { threshold: 0.25 });
    io.observe(sec);
  })();

  /* ---------- 時間軸 ---------- */
  var timeline = (function () {
    var root = document.querySelector('.ab-tl');
    if (!root) return { measure: function () {}, update: function () {} };
    var wrap = root.querySelector('.ab-tl__wrap');
    var track = root.querySelector('.ab-tl__track');
    var bar = root.querySelector('.ab-tl__bar');
    var knob = root.querySelector('.ab-tl__knob');
    var line = root.querySelector('.ab-tl__line');
    var yearsWrap = root.querySelector('.ab-tl__years');
    var years = yearsWrap ? Array.prototype.slice.call(yearsWrap.querySelectorAll('li')) : [];
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ab-tl__slide'));
    var start = 0, end = 1, vw = 0, vh = 0, maxX = 1, xStart = 0, xEnd = 0, last = -1;

    var loaded = {};
    function loadBG(i) {
      var s = slides[i]; if (!s) return;
      var m = isMobile(); var u = (m && s.dataset.bgM) ? s.dataset.bgM : s.dataset.bg; if (!u) return;
      var key = i + '|' + (m ? 'm' : 'd'); if (loaded[key]) return; loaded[key] = true;
      var el = s.querySelector('.ab-tl__bg') || s; el.style.backgroundImage = 'url("' + u + '")';
    }
    // 只載目前這張與前後各一張，其餘等捲到再載（8 張 2400px 大圖不一次全下）
    function applyBGs() { loadBG(0); loadBG(1); }
    function centerYear(i) {
      if (!isMobile() || !yearsWrap || !years[i]) return;
      var wr = yearsWrap.getBoundingClientRect(), lr = years[i].getBoundingClientRect();
      yearsWrap.scrollBy({ left: (lr.left + lr.width / 2) - (wr.left + wr.width / 2), behavior: 'smooth' });
    }
    function setActive(t) {
      var i = Math.round(t * (slides.length - 1));
      if (i === last) return;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      years.forEach(function (y, idx) { y.classList.toggle('is-active', idx === i); });
      loadBG(i - 1); loadBG(i); loadBG(i + 1); loadBG(i + 2);
      centerYear(i); last = i;
    }
    function progress(t) {
      if (isMobile()) return;
      var px = xStart + t * (xEnd - xStart);
      if (bar) bar.style.width = Math.max(0, px - xStart) + 'px';
      if (knob) knob.style.left = px + 'px';
    }
    function measure() {
      applyBGs(); vw = window.innerWidth; vh = window.innerHeight;
      if (isMobile()) {
        maxX = Math.max(1, track.scrollWidth - track.clientWidth);
        wrap.style.height = 'auto'; track.style.transform = '';
        start = pageTop(wrap); end = start;
      } else {
        var centers = years.map(function (li) { return li.offsetLeft + li.offsetWidth / 2; });
        xStart = centers[0] || 0; xEnd = centers[centers.length - 1] || (yearsWrap ? yearsWrap.clientWidth : 0);
        maxX = Math.max(0, slides.length * vw - vw);
        wrap.style.height = (maxX + vh) + 'px';
        start = pageTop(wrap); end = start + maxX;
      }
      last = -1; setActive(0); progress(0);
    }
    function update(y) {
      if (isMobile()) { var t = track.scrollLeft / maxX; setActive(clamp(t, 0, 1)); return; }
      var t2 = clamp((y - start) / Math.max(1, end - start), 0, 1);
      track.style.transform = 'translate3d(' + (-t2 * maxX) + 'px,0,0)';
      setActive(t2); progress(t2);
    }
    years.forEach(function (li, idx) {
      li.addEventListener('click', function () {
        if (isMobile()) { track.scrollTo({ left: slides[idx] ? slides[idx].offsetLeft : idx * track.clientWidth, behavior: 'smooth' }); return; }
        var t = slides.length > 1 ? idx / (slides.length - 1) : 0;
        window.scrollTo({ top: start + t * (end - start), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { if (isMobile()) update(window.scrollY); }, { passive: true });
    if (mqM.addEventListener) mqM.addEventListener('change', measure); else if (mqM.addListener) mqM.addListener(measure);
    return { measure: measure, update: update };
  })();

  /* ---------- 願景／使命 ---------- */
  var vision = (function () {
    var root = document.querySelector('.ab-vis');
    if (!root) return { measure: function () {}, update: function () {} };
    var wrap = root.querySelector('.ab-vis__wrap');
    var imgA = root.querySelector('.ab-vis__img--a'), imgB = root.querySelector('.ab-vis__img--b');
    var copyA = root.querySelector('.ab-vis__copy--a'), copyB = root.querySelector('.ab-vis__copy--b');
    var ind = root.querySelector('.ab-vis__ind');
    var start = 0, end = 1, lastT = 0;
    function measure() { start = pageTop(wrap); end = start + wrap.offsetHeight - window.innerHeight; }
    function update(y) {
      var b = clamp((y - start) / Math.max(1, end - start), 0, 1);
      var t = b * b * (3 - 2 * b);
      if (imgA) { imgA.style.clipPath = 'inset(0 ' + (t * 100).toFixed(3) + '% 0 0)'; imgA.style.transform = 'translateX(' + (-4 * t).toFixed(3) + '%)'; }
      if (imgB) { imgB.style.clipPath = 'inset(0 0 0 ' + ((1 - t) * 100).toFixed(3) + '%)'; imgB.style.transform = 'translateX(' + (4 * (1 - t)).toFixed(3) + '%)'; }
      var vg = clamp((t - 0.2) / 0.3, 0, 1), mg = clamp((t - 0.5) / 0.3, 0, 1);
      var vm = -80 * (vg * vg * (3 - 2 * vg)), mm = 80 * (1 - (mg * mg * (3 - 2 * mg)));
      var cf = clamp((t - 0.35) / 0.3, 0, 1);
      if (copyA) { copyA.style.transform = 'translate(-50%,-50%) translate3d(0,' + vm.toFixed(1) + 'px,0)'; copyA.style.opacity = (1 - cf).toFixed(3); }
      if (copyB) { copyB.style.transform = 'translate(-50%,-50%) translate3d(0,' + mm.toFixed(1) + 'px,0)'; copyB.style.opacity = cf.toFixed(3); }
      lastT = t;
    }
    if (ind) ind.addEventListener('click', function () {
      if (lastT < 0.5) { window.scrollTo({ top: start + (end - start) * 0.8, behavior: 'smooth' }); return; }
      var sec = root.closest('.shopify-section') || root; var next = sec.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' }); else window.scrollTo({ top: end + 2, behavior: 'smooth' });
    });
    return { measure: measure, update: update };
  })();

  /* ---------- 影片畫框撐滿 ---------- */
  var frame = (function () {
    var root = document.querySelector('.ab-vid');
    if (!root) return { measure: function () {}, update: function () {} };
    var pin = root.querySelector('.ab-vid__pin');
    var video = root.querySelector('.ab-vid__el');
    var sound = root.querySelector('.ab-vid__sound');
    var start = 0, end = 1, w0 = 0.84, h0 = 0.68;
    function measure() {
      var cs = getComputedStyle(root);
      w0 = parseFloat(cs.getPropertyValue('--ab-vid-w0')) || 0.84;
      h0 = parseFloat(cs.getPropertyValue('--ab-vid-h0')) || 0.68;
      start = pageTop(pin); end = start + pin.offsetHeight - window.innerHeight;
    }
    function update(y) {
      var t = smooth(0, 1, clamp((y - start) / Math.max(1, end - start), 0, 1));
      root.style.setProperty('--ab-vid-t', t.toFixed(3));
      root.style.setProperty('--ab-vid-w', (w0 + (1 - w0) * t).toFixed(4));
      root.style.setProperty('--ab-vid-h', (h0 + (1 - h0) * t).toFixed(4));
    }
    if (video) {
      // 手機用輕量的循環檔（data-src-m），桌機用完整影片
      var srcEl = video.querySelector('source');
      if (srcEl && isMobile() && srcEl.dataset.srcM) { srcEl.src = srcEl.dataset.srcM; video.load(); }
      video.addEventListener('playing', function () { root.classList.add('is-playing'); });
      // 進畫面才播、離開就停（省流量，也不會在頁面另一端一直跑）
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { video.play().catch(function () {}); } else { video.pause(); } });
        }, { threshold: 0.15 }).observe(root);
      }
      if (sound) sound.addEventListener('click', function () {
        video.muted = !video.muted; sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        if (video.paused) video.play().catch(function () {});
      });
    }
    return { measure: measure, update: update };
  })();

  /* ---------- 置中大卡片輪播（自動播、圓點） ---------- */
  (function () {
    var root = document.querySelector('.ab-val');
    if (!root) return;
    var vp = root.querySelector('.ab-val__vp');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ab-val__card'));
    var dotsWrap = root.querySelector('.ab-val__dots');
    if (!vp || cards.length < 2) return;
    var idx = 0, timer = 0, ms = parseInt(root.dataset.autoplay || '0', 10);
    var dots = cards.map(function (_, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ab-val__dot'; b.setAttribute('aria-label', '第 ' + (i + 1) + ' 張');
      b.addEventListener('click', function () { go(i); restart(); });
      if (dotsWrap) dotsWrap.appendChild(b); return b;
    });
    function go(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx];
      vp.scrollTo({ left: c.offsetLeft - (vp.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
    }
    function syncFromScroll() {
      var mid = vp.scrollLeft + vp.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
      if (best !== idx) { idx = best; dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); }); }
    }
    function restart() { if (!ms) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, ms); }
    var st = 0; vp.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(syncFromScroll, 80); }, { passive: true });
    vp.addEventListener('pointerdown', function () { clearInterval(timer); });
    vp.addEventListener('pointerup', restart);
    dots[0].classList.add('is-active'); restart();
  })();

  /* ---------- 產品線滑動：圓點＋下一張 ---------- */
  (function () {
    var root = document.querySelector('.ab-lines');
    if (!root) return;
    var track = root.querySelector('.ab-lines__track');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ab-lines__card'));
    var dotsWrap = root.querySelector('.ab-lines__dots');
    var next = root.querySelector('.ab-lines__next');
    if (!track || !cards.length) return;
    var dots = [];
    function per() { return parseFloat(getComputedStyle(track).getPropertyValue('--per')) || 1; }
    function pages() { return Math.max(1, Math.ceil(cards.length / per())); }
    function current() { var w = track.clientWidth; return w ? Math.round(track.scrollLeft / w) : 0; }
    function build() {
      if (!dotsWrap) return; dotsWrap.innerHTML = ''; dots = [];
      for (var i = 0; i < pages(); i++) (function (i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ab-lines__dot'; b.setAttribute('aria-label', '第 ' + (i + 1) + ' 頁');
        b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
        dotsWrap.appendChild(b); dots.push(b);
      })(i);
      sync();
    }
    function sync() { var c = current(); dots.forEach(function (d, j) { d.classList.toggle('is-active', j === c); }); }
    if (next) next.addEventListener('click', function () { var c = (current() + 1) % pages(); track.scrollTo({ left: c * track.clientWidth, behavior: 'smooth' }); });
    var st = 0; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 80); }, { passive: true });
    build();
    var rt = 0; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); }, { passive: true });
  })();

  /* ---------- 主迴圈（阻尼捲動、resize 節流） ---------- */
  var state = { target: window.scrollY, y: window.scrollY, damping: 0.14 };
  var mods = [hero, timeline, vision, frame];
  function measureAll() { mods.forEach(function (m) { m.measure(); }); }
  function tick() {
    state.y += (state.target - state.y) * state.damping;
    if (Math.abs(state.target - state.y) < 0.1) state.y = state.target;
    mods.forEach(function (m) { m.update(state.y); });
    requestAnimationFrame(tick);
  }
  window.addEventListener('scroll', function () { state.target = window.scrollY; }, { passive: true });
  var rraf = 0;
  window.addEventListener('resize', function () { if (rraf) return; rraf = requestAnimationFrame(function () { rraf = 0; measureAll(); state.target = window.scrollY; }); }, { passive: true });
  window.addEventListener('load', function () { measureAll(); state.target = window.scrollY; });
  document.addEventListener('shopify:section:load', function () { setTimeout(measureAll, 50); });
  measureAll(); tick();
})();
